import * as types from './types';

export const setLoading = (isLoading = true, part = 'profile') => ({
  type: types.SCHOOL_SET_LOADING,
  isLoading,
  part
});

export const setQuestionAdding = (isLoading = false, questionType) => ({
  type: types.SCHOOL_SET_QUESTION_ADDING,
  isLoading,
  questionType
});

export const setQuestionDeleting = (isLoading = false, questionType) => ({
  type: types.SCHOOL_SET_QUESTION_DELETING,
  isLoading,
  questionType
});

export const getSchoolProfile = schoolId => ({
  type: types.SCHOOL_GET_PROFILE,
  schoolId
});

export const setSchoolProfile = schoolProfile => ({
  type: types.SCHOOL_SET_PROFILE,
  schoolProfile
});

export const resetSchoolProfile = () => ({
  type: types.SCHOOL_RESET_PROFILE
});

export const getSchoolUsers = schoolId => ({
  type: types.SCHOOL_GET_USERS,
  schoolId
});

export const setSchoolUsers = schoolUsers => ({
  type: types.SCHOOL_SET_USERS,
  schoolUsers
});

export const resetSchoolUsers = () => ({
  type: types.SCHOOL_RESET_USERS
});

export const addSchoolQuestion = (schoolId, questionType, question) => ({
  type: types.SCHOOL_ADD_QUESTION,
  schoolId,
  questionType,
  question
});

export const removeSchoolQuestion = (schoolId, questionType, questionId) => ({
  type: types.SCHOOL_REMOVE_QUESTION,
  schoolId,
  questionType,
  questionId
});

export const getSchoolQuestions = (schoolId, questionsType) => ({
  type: types.SCHOOL_GET_QUESTIONS,
  schoolId,
  questionsType
});

export const setSchoolQuestions = (questions, questionsType) => ({
  type: types.SCHOOL_SET_QUESTIONS,
  questions,
  questionsType
});

export const resetSchoolQuestions = () => ({
  type: types.SCHOOL_RESET_QUESTIONS
});

export const setSchoolSettingsLoading = isLoading => ({
  type: types.SCHOOL_SET_SETTINGS_LOADING,
  isLoading
});

export const getSchoolSettings = schoolId => ({
  type: types.SCHOOL_GET_SETTINGS,
  schoolId
});

export const setSchoolSettings = settings => ({
  type: types.SCHOOL_SET_SETTINGS,
  settings
});

export const resetSchoolSettings = () => ({
  type: types.SCHOOL_RESET_SETTINGS
});

export const setSchoolSettingUpdating = isLoading => ({
  type: types.SCHOOL_SET_SETTINGS_UPDATING,
  isLoading
});

export const updateSchoolSettings = (schoolId, settings) => ({
  type: types.SCHOOL_UPDATE_SETTINGS,
  schoolId,
  settings
});

export const getSchoolVacancies = queryParams => ({
  type: types.SCHOOL_GET_VACANCIES,
  queryParams
});

export const setSchoolVacancies = schoolVacancies => ({
  type: types.SCHOOL_SET_VACANCIES,
  schoolVacancies
});

export const resetSchoolVacancies = () => ({
  type: types.SCHOOL_RESET_VACANCIES
});

export const setSchoolVacanciesStatusStats = statusStats => ({
  type: types.SCHOOL_SET_VACANCIES_STATUS_STATS,
  statusStats
});

export const getSchoolPublicProfile = schoolId => ({
  type: types.SCHOOL_GET_PUBLIC_PROFILE,
  schoolId
});

export const setSchoolPublicProfile = schoolPublicProfile => ({
  type: types.SCHOOL_SET_PUBLIC_PROFILE,
  schoolPublicProfile
});

export const getSchoolPublicVacancies = schoolId => ({
  type: types.SCHOOL_GET_PUBLIC_VACANCIES,
  schoolId
});

export const setSchoolPublicVacancies = schoolPublicVacancies => ({
  type: types.SCHOOL_SET_PUBLIC_VACANCIES,
  schoolPublicVacancies
});

export const resetSchoolPublicVacancies = () => ({
  type: types.SCHOOL_RESET_PUBLIC_VACANCIES
});

export const fetchSchoolPublicVacancyDetails = (schoolId, vacancyId) => ({
  type: types.SCHOOL_FETCH_PUBLIC_VACANCY_DETAILS,
  schoolId,
  vacancyId
});

export const setSchoolPublicVacancyDetailsLoading = isLoading => ({
  type: types.SCHOOL_SET_PUBLIC_VACANCY_DETAILS_LOADING,
  isLoading
});

export const setSchoolPublicVacancyDetails = publicVacancyDetails => ({
  type: types.SCHOOL_SET_PUBLIC_VACANCY_DETAILS,
  publicVacancyDetails
});

export const resetSchoolPublicVacancyState = () => ({
  type: types.SCHOOL_RESET_PUBLIC_VACANCY_STATE
});

export const setSchoolPublicVacancyDetailsFailedCode = failedCode => ({
  type: types.SCHOOL_SET_PUBLIC_VACANCY_DETAILS_FAILED_CODE,
  failedCode
});

export const setSchoolVacanciesQueryParams = queryParams => ({
  type: types.SCHOOL_SET_VACANCIES_QUERY_PARAMS,
  queryParams
});

export const setSchoolPriorCandidatesLoading = isLoading => ({
  type: types.SCHOOL_SET_PRIOR_CANDIDATES_LOADING,
  isLoading
});

export const getSchoolPriorCandidates = (schoolId, queryParams) => ({
  type: types.SCHOOL_GET_PRIOR_CANDIDATES,
  schoolId,
  queryParams
});

export const setSchoolPriorCandidates = schoolPriorCandidates => ({
  type: types.SCHOOL_SET_PRIOR_CANDIDATES,
  schoolPriorCandidates
});

export const resetSchoolPriorCandidates = () => ({
  type: types.SCHOOL_RESET_PRIOR_CANDIDATES
});

export const setPriorCandidatesQueryParams = queryParams => ({
  type: types.SCHOOL_VACANCY_SET_PRIOR_CANDIDATES_QUERY_PARAMS,
  queryParams
});

export const setSchoolPublicProfileFailedCode = failedCode => ({
  type: types.SCHOOL_SET_SCHOOL_PUBLIC_PROFILE_FAILED_CODE,
  failedCode
});

export const setSchoolPublicVacanciesFailedCode = failedCode => ({
  type: types.SCHOOL_SET_SCHOOL_PUBLIC_VACANCIES_FAILED_CODE,
  failedCode
});



// WEBPACK FOOTER //
// ./src/actions/school/index.js